import angular from 'angular';
import constants from 'app/constants';
import incompleteAssessment from './incompleteAssessment';
import completedAssessment from './completedAssessment';
import directive from './assessments.directive';


export default angular.module('app.components.advisory.bcp.assessments', [
  completedAssessment,
  constants,
  incompleteAssessment,
])
  .directive('bcpAssessments', directive)
  .controller('AssessmentsController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.bcp.assessments created');
